import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function Accordion({ items }) {
    const {t , i18n} = useTranslation();
    const [openIndices, setOpenIndices] = useState([0]);

    const toggleAccordion = (index) => {
        setOpenIndices(prev =>
            prev.includes(index)
                ? prev.filter(i => i !== index)
                : [...prev, index]
        );
    };

    return (
        <div className="w-full">
            {items.map((item, index) => (
                <div key={item.id} className="mb-4">
                    <button
                        type="button"
                        className={`flex items-center justify-between w-full p-5 text-left font-medium text-gray-200 hover:text-white bg-[#141618] hover:bg-[#1a1c1e] rounded-lg transition-all duration-300 ease-in-out ${openIndices.includes(index) ? 'border border-[#ff014f]' : ''}`}
                        onClick={() => toggleAccordion(index)}
                        aria-expanded={openIndices.includes(index)}
                    >
                        <span className="flex items-center">
                            {item.icon}
                            {t(`${item.nameKey}`)}
                        </span>
                        <svg
                            className={`w-4 h-4 transition-transform duration-300 ease-in-out ${openIndices.includes(index) ? 'transform rotate-180' : ''}`}
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>

                    <div
                        className={`transition-all duration-300 ease-in-out overflow-hidden ${openIndices.includes(index) ? 'opacity-100' : 'max-h-0 opacity-0'}`}
                    >
                        <div className="pt-[15px] pb-14 bg-[#212428] rounded-b-lg border border-t-0 border-gray-700" style={{border : 'none' , paddingLeft : '10px' , paddingRight : '10px'}}>
                            {item.component}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Accordion;